<template>
  <div>
    <doc-title :text="title" v-if="title"/>
    <slot></slot>
  </div>
</template>

<script>
  import DocTitle from '@/vues/helpers/doc-title.vue';

  export default {
    name: 'Yield',
    components: { DocTitle },
    props: {
      title: {
        type: String,
        default: ''
      }
    }
  };
</script>
